import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetChallengeInsightProgressDigitalIntensitySummaryApplicationService } from '../../../core/application/services/challenge-insights/get-challenge-insight-progress-digital-intensity-summary.application-service';
import { ChallengeInsightProgressDigitalIntensitySummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-digital-intensity.aggregate-root';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';

export class GetChallengeInsightProgressDigitalIntensitySummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetChallengeInsightProgressDigitalIntensitySummaryApplicationService
  ) {}
  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressDigitalIntensitySummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
